export default "__VITE_ASSET__BmC8vW4I__"